import React from 'react'

import weight_loss_icon from "../../assets/weight-loss-icon.png";
import get_fit_icon from "../../assets/get-fit-icon.png";
import stay_fit_icon from "../../assets/stay-fit-icon.png";
import keep_moving_icon from "../../assets/keep-moving-icon.png";

export default function Choose(props) {

    const handleChoice = function (choice) {
        props.context.actions.updateState("userChoice", choice)
        // console.log("selection:", choice, "context:", props.context.userChoice);
        props.history.push("/packages/")
    }

    return (
        <section className="choose" id="choose">
        <article className="choose-header">
          <h2>Choose Your Fitness Goals</h2>
          <p>
            Whether your fitness goals are centered around WEIGHT LOSS, GET FIT,
            STAY FIT or KEEP MOVING, IGLF has the tools and resources to set you
            up for success!
            
            Select any combination of the following four components to begin
            building your own fitness package:
            
            1) Wellness Assessment 2) Metabolic Testing 3) Nutrition Coaching 4)
            Personal Training.
          </p>
        </article>
        <article className="choose-packages">
          <div className="row">
            <div className="box" id="weight-loss">
              <div className="box-display">
                <div className="icon">
                  <img src={weight_loss_icon} width="200" height="200" alt="Scale" />
                </div>
                <h3>Weight Loss</h3>
              </div>
              <div className="box-details">
                <h3>
                  Starts at
                  <br />
                  <span>$695</span>
                </h3>
                <p>18 personal training sessions (30 minutes each)</p>
                <p>2 Metabolic Tests</p>
                <p>Meal Plan</p>
                <p>4 Virtual Touchpoint Meetings</p>
                <div className="cta" onClick={(e) => handleChoice("weight_loss")}>
                  See More...
                </div>
              </div>
            </div>
            {/* ********* */}
            <div className="box" id="get-fit">
              <div className="box-display">
                <div className="icon">
                  <img src={get_fit_icon} width="200" height="200" alt="Scale" />
                </div>
                <h3>Get Fit</h3>
              </div>
              <div className="box-details">
                <h3>
                  Starts at
                  <br />
                  <span>$1095</span>
                </h3>
                <p>18 personal training sessions (60 minutes each)</p>
                <p>Metabolic Tests</p>
                <p>Meal Plan</p>
                <p>4 Virtual Touchpoint Meetings</p>
                <div className="cta" onClick={(e) => handleChoice("get_fit")}>
                  See More...
                </div>
              </div>
            </div>
          
          {/* ********* */}
          
            <div className="box" id="stay-fit">
              <div className="box-display">
                <div className="icon">
                  <img src={stay_fit_icon} width="200" height="200" alt="Scale" />
                </div>
                <h3>Stay Fit</h3>
              </div>
              <div className="box-details">
                <h3>
                  Starts at
                  <br />
                  <span>$750</span>
                </h3>
                <p>18 personal training sessions (60 minutes each)</p>
                <p>1 Metabolic Test</p>
                <p>Nutrition Consultation</p>
                <p>Training Plan Development</p>
                <div className="cta" onClick={(e) => handleChoice("stay_fit")}>
                  See More...
                </div>
              </div>
            </div>
            {/* ********* */}
            <div className="box" id="keep-moving">
              <div className="box-display">
                <div className="icon">
                  <img src={keep_moving_icon} width="200" height="200" alt="Scale" />
                </div>
                <h3>Keep Moving</h3>
              </div>
              <div className="box-details">
                <h3>
                  Starts at
                  <br />
                  <span>$605</span>
                </h3>
                <p>18 personal training sessions (30 minutes each)</p>
                <p>2 Metabolic Tests</p>
                <p>Meal Plan</p>
                <p>4 Virtual Touchpoint Meetings</p>
                <div className="cta" onClick={(e) => handleChoice("keep_moving")}>
                  See More...
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    )
}
